<template>
	<div>
		<div class="home__header">
			<div class="home__header__action">
				<p class="home__header__action__title">Studeer Stipt.</p>
				<router-link
					class="home__header__action__login"
					to="/login">
					<a>Login</a>
				</router-link>
				<router-link
					class="home__header__action__register"
					to="/register">
					<a>Register</a>
				</router-link>
			</div>
		</div>
	</div>
</template>

<script>
// import API from '@/services/API.js'

export default {
	data () {
		return {
		}
	}
}
</script>

<style lang="scss" scoped>
@import '@/styles/views/_home.scss'
</style>
